import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  ProgressBar,
  Button,
  Card,
  Modal,
  Alert,
} from "react-bootstrap";
import backgroundImage2 from "../assets/Bottom_Artwork.jpg";
import { getData, postData } from "../utils/requests";
import Option from "./Option/Option";
import clock from "../assets/clock.svg";
import siemens_logo from "../assets/siemens_logo.svg";

const TIMER = 30;

const Quiz = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  let [selectedAnswer, setSelectedAnswer] = useState("");
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(TIMER); // 10 minutes in seconds
  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const fetchQuestions = async (page) => {
    setLoading(true);
    try {
      // const response = await axios.get(`/questions?limit=5&page=${page}`);
      const { questions } = await getData("quiz/questions");
      if (questions.length > 0) {
        setQuestions(questions);
        localStorage.setItem("quizQuestions", JSON.stringify(questions));
        localStorage.removeItem("currentQuestionIndex");
        localStorage.removeItem("answeredQuestions");

        // Update quiz_start_time after fetching questions successfully
        try {
          await postData(`quiz/start`);
        } catch (error) {
          if (error.response && error.response.data) {
            setErrorMessage(error.response.data.error);
            setShowModal(true);
          } else {
            setErrorMessage("An unexpected error occurred. Please try again.");
          }
        }
      } else {
        alert("No questions available.");
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedQuestions = localStorage.getItem("quizQuestions");
    const storedCurrentQuestion = localStorage.getItem("currentQuestionIndex");
    const storedAnswers = localStorage.getItem("answeredQuestions");

    if (storedCurrentQuestion >= 5) {
      //navigate("/register");
      fetchQuestions(1);
    }

    if (storedQuestions) {
      setQuestions(JSON.parse(storedQuestions));
      setCurrentQuestion(
        storedCurrentQuestion ? parseInt(storedCurrentQuestion) : 0
      );
      setSelectedAnswer(
        storedAnswers ? JSON.parse(storedAnswers)[storedCurrentQuestion] : ""
      );
      console.log("Quiz state restored from localStorage.");
    } else {
      fetchQuestions(1);
    }
  }, []);

  // Clear localStorage when coming from registration page
  useEffect(() => {
    if (document.referrer.includes("/register")) {
      localStorage.removeItem("quizQuestions");
      console.log("Cleared localStorage due to registration.");
    }
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);

          handleNext();
          return TIMER;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [currentQuestion]);

  const handleOptionSelect = (option) => {
    setSelectedAnswer(option);
  };

  const handleNext = async () => {
    if (!selectedAnswer) selectedAnswer = ""; // Ensure the user has selected an answer
    let questions = JSON.parse(localStorage.getItem("quizQuestions"));

    const currentQuestionObj = questions[currentQuestion]; // Replace `questionst` with your `questions` state if using the API response
    const isCorrect = selectedAnswer === currentQuestionObj?.correct_answer;

    try {
      // API call to submit the answer
      const response = await postData(`quiz/answer`, {
        questionId: currentQuestionObj.id,
        isCorrect, // Whether the answer was correct
        selectedAnswer,
      });

      console.log("Answer submission response:", response.data);

      // Save the current state
      const answeredQuestions = localStorage.getItem("answeredQuestions")
        ? JSON.parse(localStorage.getItem("answeredQuestions"))
        : {};
      answeredQuestions[currentQuestion] = selectedAnswer;
      localStorage.setItem(
        "answeredQuestions",
        JSON.stringify(answeredQuestions)
      );
      localStorage.setItem("currentQuestionIndex", currentQuestion + 1);

      // Reset the timer to 30 seconds
      setTimeLeft(TIMER);

      // Move to the next question
      if (currentQuestion < questions.length - 1) {
        setCurrentQuestion(currentQuestion + 1);
        setProgress(((currentQuestion + 1) / questions.length) * 100);
        setSelectedAnswer("");
      } else {
        //alert("Quiz completed! Submitting your answers...");
        // Optionally submit the full quiz or navigate to another page
        handleSubmitQuiz();
      }
    } catch (error) {
      console.error("Error submitting answer:", error);
    }
  };

  const handleSubmitQuiz = async () => {
    try {
      // Show a confirmation
      //alert("Quiz submitted!");

      // Update the user's quiz_end_time
      await postData(`quiz/complete`);

      // Navigate to the leaderboard page
      navigate(`/leaderboard`);
    } catch (error) {
      console.error("Failed to submit quiz:", error);
      alert("Failed to submit the quiz. Please try again.");
    }
  };

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        color: "#ffffff",
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 30px",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "30px",
          right: "30px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/*<h2 style={{ fontSize: "2.9rem", fontWeight: "bold", color: "#fff" }}>
          COACT
        </h2>*/}
         <img
          src={siemens_logo}
          alt="logo"
          style={{ width: "150px", height: "80px" }}
        /> 
        <div
          id="timer"
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#00ffb9",
            display: "flex",
            alignItems: "center",
            gap: "10px", // Adds spacing between the icon and text
            justifyContent: "flex-end", // Pushes it to the right
          }}
        >
          <img src={clock} alt="Clock Icon" width="40" height="40" />
          {formatTime(timeLeft)}
        </div>
      </div>

      <div
        style={{
          maxWidth: "45%",
          margin: "0 auto",
          padding: "20px",
          zIndex: 1,
        }}
      >
        <div className="d-flex justify-content-between mb-4 btn-circle">
          {questions.map((_, index) => (
            <div
              key={index}
              className="circle"
              style={{
                backgroundColor:
                  currentQuestion === index ? "#01E2DC" : "#C4FFED",
              }}
            >
              {index + 1}
            </div>
          ))}
        </div>

        {/* <ProgressBar
          now={progress}
          label={`${Math.round(progress)}%`}
          animated
          striped
          variant="info"
          className="mb-4"
          style={{ backgroundColor: "#1a1a40" }}
        /> */}

        {!loading && questions.length > 0 ? (
          <Card
            className="text-center mb-4 shadow-lg"
            style={{
              backgroundColor: "transparent",
              color: "#fff",
            }}
          >
            <Card.Body
              style={{ backgroundColor: "transparent", color: "#fff" }}
            >
              <Card.Title className="mb-4">
                {questions[currentQuestion]?.question}
              </Card.Title>
              <div className="d-flex flex-column">
                <Option
                  handleOptionSelect={handleOptionSelect}
                  selectedAnswer={selectedAnswer}
                  option={questions[currentQuestion]?.option1}
                />
                <Option
                  handleOptionSelect={handleOptionSelect}
                  selectedAnswer={selectedAnswer}
                  option={questions[currentQuestion]?.option2}
                />
                <Option
                  handleOptionSelect={handleOptionSelect}
                  selectedAnswer={selectedAnswer}
                  option={questions[currentQuestion]?.option3}
                />
                <Option
                  handleOptionSelect={handleOptionSelect}
                  selectedAnswer={selectedAnswer}
                  option={questions[currentQuestion]?.option4}
                />
              </div>
            </Card.Body>
          </Card>
        ) : (
          <p className="text-center text-white">Loading questions...</p>
        )}






<div className="d-flex justify-content-center">
  <Button
    onClick={handleNext}
    disabled={!selectedAnswer}
    style={{
      backgroundColor: "#002244",
      borderRadius: "30px",
      border: "2px solid #ffffff",
      padding: "10px 40px",
      color: "#ffffff",
      fontWeight: "750",
      fontWeight: "bold",
      fontSize: "1.2rem",
      letterSpacing: "1px",
      backdropFilter: "blur(4px)",
      //boxShadow: "0 0 12px #ffffff",
      marginTop: "-15px",
      opacity:100,
    }}
  >
    {currentQuestion === questions.length - 1 ? "Submit" : "Next"}
  </Button>
</div>







      {/* <div
        style={{
          flexBasis: "50%",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <img
          src={backgroundImage}
          alt="background"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            maxWidth: "600px",
            maxHeight: "80vh",
          }}
        />
      </div> */}

      {/* Error Modal */}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false); // Close the modal
          navigate("/register"); // Redirect to the register page
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">{errorMessage}</Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModal(false); // Close the modal
              navigate("/register"); // Redirect to the register page
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    </div>
  );
};

export default Quiz;
